import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFaqs } from '../redux/faqSlice';
import useScreenSize from '../hooks/useScreenSize';

const Faqs = ({ showLimit }) => {
    const { isMobile } = useScreenSize();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data: faqs = [], status } = useSelector((state) => state.faqs);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(getFaqs());
        }
    }, [dispatch, status]);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const displayedFaqs = showLimit ? faqs.slice(0, showLimit) : faqs;

    const renderFaqList = (list) => (
        <div className='faq-accordion'>
            {list.map((faq, index) => {
                return (
                    <div
                        className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                        key={faq.faq_id}
                    >
                        <div
                            className='faq-question'
                            onClick={() => toggleAccordion(index)}
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    toggleAccordion(index);
                                }
                            }}
                            aria-expanded={activeIndex === index}
                        >
                            <h3>{faq.faq_question}</h3>
                            <div className={`faq-icon ${activeIndex === index ? 'rotate' : ''}`}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </div>
                        <div
                            className={`faq-answer ${activeIndex === index ? 'show' : ''}`}
                        >
                            <p>{faq.faq_answer}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );

    return (
        <div className="row">
            <div className="col-12 text-center">
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-10 p-0'>
                            <div className={`d-flex ${isMobile ? 'justify-content-start' : 'justify-content-center'} align-items-center mb-md-4 mb-3 mt-md-4 mt-3 position-relative`}>
                                {!showLimit && (
                                    <div className={`align-items-center ${isMobile ? '' : 'position-absolute start-0'}`}>
                                        <button
                                            onClick={() => navigate('/')}
                                            className="btn btn-primary d-flex align-items-center justify-content-center border-0 shadow-sm me-3 p-2 px-md-3"
                                            style={{
                                                background: 'linear-gradient(to bottom, #0082CB 0%, #004E7A 100%)',
                                                width: 'auto',
                                                height: isMobile ? '35px' : '40px',
                                                borderRadius: '48px',
                                            }}
                                            title="Back to Home"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                                <polyline points="12 19 5 12 12 5"></polyline>
                                            </svg>
                                            <span className="d-none d-md-inline ms-2">Back To Home</span>
                                        </button>
                                    </div>
                                )}
                                <div className="text-center">
                                    <h2 className='heading w-100 text-center m-0'>Frequently Asked Questions</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 pb-md-5 pb-3">
                {status === 'loading' && <p>Loading...</p>}
                {status === 'failed' && <p>Failed to load FAQs.</p>}
                {status === 'succeeded' && faqs.length === 0 && <p>No FAQs available.</p>}
                {status === 'succeeded' && faqs.length > 0 && (
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-12 col-md-10 p-0'>
                                {renderFaqList(displayedFaqs)}
                            </div>
                            {showLimit && faqs.length > showLimit && (
                                <div className="d-flex justify-content-center mt-2">
                                    <button
                                        onClick={() => navigate('/faqs')}
                                        className="btn btn-primary px-4 py-3 sin-button rounded-pill shadow-sm border-0"
                                        style={{ background: 'linear-gradient(to bottom, #0082CB 0%, #004E7A 100%)' }}
                                    >
                                        Show All FAQs
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Faqs;
